import React from 'react'

import { withState } from 'recompose'
import CopyToClipboard from 'react-copy-to-clipboard'

import HoverTooltip from '../Controls/HoverTooltip'

const CopyWithTooltip = withState('copied', 'setCopied', false)(
  ({ copied, setCopied, text, children, id, labelBefore, labelAfter }) => {
    return (
      <HoverTooltip
        className="dib"
        colorClass="white"
        arrowClass="dark-gray"
        backgroundClass="bg-dark-gray"
        tip={copied ? labelAfter : labelBefore}
      >
        <CopyToClipboard text={text} onCopy={() => setCopied(true)}>
          {children}
        </CopyToClipboard>
      </HoverTooltip>
    )
  }
)

export default CopyWithTooltip



// WEBPACK FOOTER //
// ./src/components/polls/CopyWithTooltip.js